import React from "react"
import styled from "styled-components"
import { uniqueId } from "lodash"
import { AppFunctionComponent } from "../../types"

const Arrow = styled.svg<{ type: "left" | "right" }>`
  transform: rotate(${({ type }) => (type === "left" ? "180" : "0")}deg);
`

interface Props {
  title?: string
  type: "left" | "right"
  className?: string
}

const NavigationArrow: AppFunctionComponent<Props> = ({
  className,
  title,
  type,
}) => {
  const id = uniqueId()

  return (
    <Arrow
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
      className={className}
      type={type}
      aria-labelledby={id}
    >
      <title id={id}>{title}</title>
      <path d="M7.3 20.3c-.4.4-.4 1 0 1.4s1 .4 1.4 0l10-10.1c.4-.4.4-1 0-1.4L8.8.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l9.2 9.2-9.3 9.4z" />
    </Arrow>
  )
}

export default NavigationArrow
